import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const LabOrderDetailPage = lazy(
  () => import('@/pages/lab-order-detail/ui/LabOrderDetailPage'),
)

export const Route = createFileRoute('/_protected/laboratory/$orderId')({
  component: LabOrderDetailRoute,
})

function LabOrderDetailRoute() {
  const { orderId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <LabOrderDetailPage orderId={orderId} />
    </Suspense>
  )
}
